import {AceServe, ErrorServe, isAceServe, isErrorServe, ReceivedServe} from "../types/servce-info.type";
import {StattedPointDto} from "../dtos/statted-point.dto";
import {
  AttackWithoutAttackType,
  AttackWithoutAttackTypeOrOriginLocation,
  AttackWithOutLocation,
  AttackWithoutDestinationLocation,
  AttackWithDestinationLocation,
  isAttackWithoutAttackType,
  isAttackWithoutAttackTypeOrOriginLocation,
  isAttackWithOutLocation,
  isAttackWithoutDestinationLocation,
  isAttackWithDestinationLocation
} from "../types/attack-info.type";

export const buildPointHandler = <T>(
  onErrorServe: (serve: ErrorServe, point: StattedPointDto) => T,
  onAce: (serve: AceServe, point: StattedPointDto) => T,
  onAttackWithoutAttackTypeOrOriginLocation: (serve: ReceivedServe, attack: AttackWithoutAttackTypeOrOriginLocation, point: StattedPointDto) => T,
  onAttackWithoutDestinationLocation: (serve: ReceivedServe, attack: AttackWithoutDestinationLocation, point: StattedPointDto) => T,
  onAttackWithDestinationLocation: (serve: ReceivedServe, attack: AttackWithDestinationLocation, point: StattedPointDto) => T,
  onAttackWithOutLocation: (serve: ReceivedServe, attack: AttackWithOutLocation, point: StattedPointDto) => T,
  onAttackWithoutAttackType: (serve: ReceivedServe, attack: AttackWithoutAttackType, point: StattedPointDto) => T
) => (point: StattedPointDto) => {
  if(isErrorServe(point.serveInfo)) {
    return onErrorServe(point.serveInfo, point);
  }
  if(isAceServe(point.serveInfo)) {
    return onAce(point.serveInfo, point);
  }
  if(!point.attackInfo) {
    throw new Error(`Point has serve in place but no attack info: ${point}`);
  }
  if(isAttackWithoutAttackTypeOrOriginLocation(point.attackInfo)) {
    return onAttackWithoutAttackTypeOrOriginLocation(point.serveInfo, point.attackInfo, point);
  }
  if(isAttackWithoutDestinationLocation(point.attackInfo)) {
    return onAttackWithoutDestinationLocation(point.serveInfo, point.attackInfo, point);
  }
  if(isAttackWithDestinationLocation(point.attackInfo)) {
    return onAttackWithDestinationLocation(point.serveInfo, point.attackInfo, point);
  }
  if(isAttackWithOutLocation(point.attackInfo)) {
    return onAttackWithOutLocation(point.serveInfo, point.attackInfo, point);
  }
  if(isAttackWithoutAttackType(point.attackInfo)) {
    return onAttackWithoutAttackType(point.serveInfo, point.attackInfo, point);
  }
  throw new Error(`Point has unknown attack info subtype ${point}`);
}